import { appConfig } from 'brand-config';

/**
 * Whether this brand offers the staff "Create Payment Link" billing action (#36685): a 30-day link to
 * the account site's /pay page, where anyone can pay the policy without signing in. On for CFM, off
 * (unset) for the rest. Mirrors brand-config-be's featureFlags.guestPayment, which core-resources
 * enforces; the action is additionally gated by canEditPolicies, and core-resources limits agents to
 * their own book.
 */
export const isGuestPaymentLinkAllowed = () => Boolean(appConfig?.featureFlags?.guestPaymentLinks);
